import { render, staticRenderFns } from "./checkLastnameFailed.vue?vue&type=template&id=f8ffb2a2&scoped=true&"
import script from "./checkLastnameFailed.vue?vue&type=script&lang=js&"
export * from "./checkLastnameFailed.vue?vue&type=script&lang=js&"
import style0 from "./checkLastnameFailed.vue?vue&type=style&index=0&id=f8ffb2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ffb2a2",
  null
  
)

export default component.exports